export const OPEN_IN_NEW_TAB_TITLE = 'newtab';
export const OPEN_IN_NEW_TAB_ATTR = 'data-open-in-new-tab';

// SVG path sourced from trellis-assets/icons/components/LinkExternalIcon.
// Injected as HTML so no React component or html-react-parser is needed.
export const EXTERNAL_LINK_ICON_HTML = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" focusable="false" aria-hidden="true" data-icon-name="LinkExternal" style="display:inline-block;block-size:1em;inline-size:1em;vertical-align:-0.125em;color:inherit;margin-inline-start:0.25em"><path fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M14.273 17.727 27 5M19 5h8v8M15 9H7v16h16v-8"/></svg>';
export const isSkippedHrefProtocol = href => {
  var _href$split$;
  if (!href) return true;
  const protocol = (_href$split$ = href.split(':', 1)[0]) === null || _href$split$ === void 0 ? void 0 : _href$split$.toLowerCase();
  return protocol === 'mailto' || protocol === 'tel';
};
export const promoteNewTabTitleOnAnchor = anchor => {
  const title = anchor.getAttribute('title');
  if (title === OPEN_IN_NEW_TAB_TITLE) {
    anchor.setAttribute(OPEN_IN_NEW_TAB_ATTR, 'true');
    anchor.removeAttribute('title');
  }
  return anchor.hasAttribute(OPEN_IN_NEW_TAB_ATTR);
};
export const applyOpenInNewTabMarkdownPlugin = md => {
  const defaultRender = md.renderer.rules.link_open || ((tokens, idx, options, _env, self) => self.renderToken(tokens, idx, options));
  md.renderer.rules.link_open = (tokens, idx, options, env, self) => {
    const token = tokens[idx];
    if (token.attrGet('title') === OPEN_IN_NEW_TAB_TITLE) {
      token.attrSet(OPEN_IN_NEW_TAB_ATTR, 'true');
      const titleIndex = token.attrIndex('title');
      if (titleIndex >= 0 && token.attrs) {
        token.attrs.splice(titleIndex, 1);
      }
    }
    return defaultRender(tokens, idx, options, env, self);
  };
};